import { TableCell } from "@mui/material";
import {
  IAdditional,
  IAdditionalHeaderProps,
} from "../../TableTemplate/tableTemplate";
import Button from "../../../Components/Button";
import EditIcon from "@mui/icons-material/Edit";
import {
  IDecrementalTableReport,
  IIncrementalTableReport,
} from "../../../Interfaces/deltaHedgeSettings";
import { useAppDispatch, useAppSelector } from "../../../App/hooks";
import {
  setAddEditDecrementalFormValues,
  setAddEditIncrementalFormValues,
  setDecrementalEditFlag,
  setDecrementalTableFlag,
  setHeltaHedgeSettingsAddEditModalFlag,
  setIncrementalEditFlag,
  setIncrementalTableFlag,
} from "../../../Features/DeltaHedgeSettings/deltaHedgeSettingsSlice";
import { useEffect } from "react";

const AdditionalHeader = ({}: IAdditionalHeaderProps) => {
  return (
    <>
      <TableCell />
    </>
  );
};

const AdditionalCol: React.FC<{
  row: IDecrementalTableReport;
  onAction: () => void;
}> = ({ row, onAction }) => {
  const dispatch = useAppDispatch();
  const flag = useAppSelector(
    (store) => store.deltaHedgeSettingsSlice.decrementalTableRefetchFlag
  );
  const editHandler = () => {
    dispatch(setAddEditDecrementalFormValues(row));
    dispatch(setDecrementalEditFlag(true));
    dispatch(setHeltaHedgeSettingsAddEditModalFlag(true));
  };

  useEffect(() => {
    if (flag) {
      onAction();
      dispatch(setDecrementalTableFlag(false));
    }
  }, [flag]);

  return (
    <>
      <TableCell>
        <div className="w-32">
          <Button
            text={<EditIcon className="!text-sm" />}
            variant="contained"
            className="table-btn"
            onClick={editHandler}
          />
        </div>
      </TableCell>
    </>
  );
};

export const Additional: IAdditional<IDecrementalTableReport> = {
  getHeader: AdditionalHeader,
  getRow: AdditionalCol,
};
